// src/components/PrincipalMessage.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../css/PrincipalMessage.css';
import DefaultImg from '../image/np1747056943_cab87dabff61368c0ba7.png';

const PrincipalMessage = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchPrincipalMessage = async () => {
      try {
        const res = await axios.get('https://college-c1-backend.onrender.com/api/admin/principalMessage');
        setData(res.data);
      } catch (error) {
        console.error('Error fetching principal message:', error);
      }
    };

    fetchPrincipalMessage();
  }, []);

  return (
    <section className="principal-message">
      <div className="container h2">
        <h2>{data?.title || 'Message From Principal'}</h2>
        <div className="content">
          <div className="image">
            <div className="placeholder-image">
              <img
                src={
                  data?.photo
                    ? `https://college-c1-backend.onrender.com/${data.photo.replace(/\\/g, '/')}`
                    : DefaultImg
                }
                alt="Principal"
              />
            </div>
          </div>
          <div className="text">
            <p>
              {data?.description ||
                'Welcome to S.N. Sinha College, Warisaliganj, Nawada, Bihar-805 130. We take pride in shaping and redefining quality education for our students.'}
            </p>
            <p className="read-more">Read More</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrincipalMessage;
